import React, { useState } from "react";
import "../Style.scss";
import SideNav from "./TopSideNav";
import opgLogo from "../../Assets/Images/OPG_logo.svg";

// var prevScrollpos = window.pageYOffset;
// window.onscroll = function () {
//   var currentScrollPos = window.pageYOffset;
//   if (prevScrollpos > currentScrollPos) {
//     document.getElementById("navbar").style.top = "0";
//   } else {
//     document.getElementById("navbar").style.top = "-120px";
//   }
//   prevScrollpos = currentScrollPos;
// };

const NavBar = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  return (
    <>
      <nav
        className="navbar sticky-top navbar-expand-lg custom-navbar"
        id="navbar"
      >
        <div className="container toggle_icon">
          <a className="navbar-brand" href="/">
            <img
              className="brand"
              src={opgLogo}
              alt="OPG Securities"
              title="OPG Securities"
            />
          </a>
          <SideNav />
          <div
            className={`${isNavCollapsed ? "collapse" : ""}
                            navbar-collapse justify-content-end miniLaptopNav`}
            id=""
          >
            <ul className="navbar-nav justify-content-end mb-2 mb-lg-0">
              <li className="nav-item">
                <a href="/" className="nav-link" title="about">
                  About
                </a>
              </li>
              <li className="nav-item">
                <a href="contact" className="nav-link" title="contact">
                  Contact
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="http://rms.opgsecurities.com:8888/WEBR"
                  className="nav-link primaryColor"
                  title="risk management system"
                >
                  RMS
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="http://ipo.opgsecurities.com:7000/"
                  className="nav-link primaryColor"
                  title="initial public offerings"
                >
                  IPO
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="https://122.160.40.174:10443/"
                  className="nav-link primaryColor"
                >
                  Backoffice
                </a>
              </li>
              {/* <li className="nav-item">
                <a
                  href="http://oats.opgsecurities.com:3000/#/app"
                  className="nav-link primaryColor"
                >
                  OATS
                </a>
              </li> */}
              <li className="nav-item">
                <a href="download" className="nav-link primaryColor">
                  Downloads
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavBar;
